 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-perfil-pago-perfil-pago-module":"pages-perfil-pago-perfil-pago-module","pages-recuperar-contrasenia-recuperar-contrasenia-module":"pages-recuperar-contrasenia-recuperar-contrasenia-module","core-js-js":"core-js-js","default~pages-editar-link-editar-link-module~pages-faq-faq-module~pages-inicio-inicio-module~pages-l~072fee15":"default~pages-editar-link-editar-link-module~pages-faq-faq-module~pages-inicio-inicio-module~pages-l~072fee15","pages-editar-link-editar-link-module":"pages-editar-link-editar-link-module","pages-nuevo-link-nuevo-link-module":"pages-nuevo-link-nuevo-link-module","pages-tokens-tokens-module":"pages-tokens-tokens-module","default~pages-inicio-inicio-module~pages-nueva-contrasenia-nueva-contrasenia-module~pages-registro-r~b0f9ac5d":"default~pages-inicio-inicio-module~pages-nueva-contrasenia-nueva-contrasenia-module~pages-registro-r~b0f9ac5d","pages-inicio-inicio-module":"pages-inicio-inicio-module","default~pages-link-link-module~pages-pago-pago-module~pages-pos-movil-pos-movil-module~pages-pos-pos-module":"default~pages-link-link-module~pages-pago-pago-module~pages-pos-movil-pos-movil-module~pages-pos-pos-module","pages-pos-pos-module":"pages-pos-pos-module","pages-link-pago-link-pago-module":"pages-link-pago-link-pago-module","pages-listado-transacciones-listado-transacciones-module":"pages-listado-transacciones-listado-transacciones-module","pages-resumen-transacciones-resumen-transacciones-module":"pages-resumen-transacciones-resumen-transacciones-module","default~pages-facturador-facturador-module~pages-modal-facturador-modal-facturador-module":"default~pages-facturador-facturador-module~pages-modal-facturador-modal-facturador-module","pages-facturador-facturador-module":"pages-facturador-facturador-module","pages-nueva-contrasenia-nueva-contrasenia-module":"pages-nueva-contrasenia-nueva-contrasenia-module","pages-registro-registro-module":"pages-registro-registro-module","pages-link-link-module":"pages-link-link-module","pages-pago-pago-module":"pages-pago-pago-module","pages-pos-movil-pos-movil-module":"pages-pos-movil-pos-movil-module","default~pages-pagos-usuario-pagos-usuario-module~pagos-usuario-pagos-usuario-module":"default~pages-pagos-usuario-pagos-usuario-module~pagos-usuario-pagos-usuario-module","pages-pagos-usuario-pagos-usuario-module":"pages-pagos-usuario-pagos-usuario-module","dom-js":"dom-js","pages-agregar-establecimiento-agregar-establecimiento-module":"pages-agregar-establecimiento-agregar-establecimiento-module","pages-agregar-frase-agregar-frase-module":"pages-agregar-frase-agregar-frase-module","pages-ayuda-ayuda-module":"pages-ayuda-ayuda-module","pages-ayuda-pay-ayuda-pay-module":"pages-ayuda-pay-ayuda-pay-module","pages-cliente-cliente-module":"pages-cliente-cliente-module","pages-detalle-listado-facturas-detalle-listado-facturas-module":"pages-detalle-listado-facturas-detalle-listado-facturas-module","pages-editar-cliente-editar-cliente-module":"pages-editar-cliente-editar-cliente-module","pages-establecimientos-establecimientos-module":"pages-establecimientos-establecimientos-module","pages-factura-procesada-factura-procesada-module":"pages-factura-procesada-factura-procesada-module","pages-frases-frases-module":"pages-frases-frases-module","pages-home-home-module":"pages-home-home-module","pages-home-principal-home-principal-module":"pages-home-principal-home-principal-module","pages-landing-landing-module":"pages-landing-landing-module","pages-link-exito-link-exito-module":"pages-link-exito-link-exito-module","pages-listado-facturas-listado-facturas-module":"pages-listado-facturas-listado-facturas-module","pages-nfc-prueba-nfc-prueba-module":"pages-nfc-prueba-nfc-prueba-module","pages-pago-exito-cyber-pago-exito-cyber-module":"pages-pago-exito-cyber-pago-exito-cyber-module","pages-pago-exito-pago-exito-module":"pages-pago-exito-pago-exito-module","pages-pago-exito-public-pago-exito-public-module":"pages-pago-exito-public-pago-exito-public-module","pages-paso2-paquetes-paso2-paquetes-module":"pages-paso2-paquetes-paso2-paquetes-module","pages-perfil-admin-perfil-admin-module":"pages-perfil-admin-perfil-admin-module","pages-perfil-tributario-perfil-tributario-module":"pages-perfil-tributario-perfil-tributario-module","pages-perfil-usuario-tabs-perfil-usuario-tabs-module":"pages-perfil-usuario-tabs-perfil-usuario-tabs-module","pages-punto-venta-punto-venta-module":"pages-punto-venta-punto-venta-module","pages-recurrencia-exito-recurrencia-exito-module":"pages-recurrencia-exito-recurrencia-exito-module","pages-registro-cliente-registro-cliente-module":"pages-registro-cliente-registro-cliente-module","pages-registro-exito-registro-exito-module":"pages-registro-exito-registro-exito-module","pages-resumen-facturacion-resumen-facturacion-module":"pages-resumen-facturacion-resumen-facturacion-module","pages-terms-conditions-terms-conditions-module":"pages-terms-conditions-terms-conditions-module","pages-usuarios-partner-usuarios-partner-module":"pages-usuarios-partner-usuarios-partner-module","pages-usuarios-usuarios-module":"pages-usuarios-usuarios-module","pages-ventas-partner-ventas-partner-module":"pages-ventas-partner-ventas-partner-module","pages-ventas-ventas-module":"pages-ventas-ventas-module","perfil-usuario-perfil-usuario-module":"perfil-usuario-perfil-usuario-module","shadow-css-d7d058ec-d59cb009-js":"shadow-css-d7d058ec-d59cb009-js","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom","swiper-bundle-ccdaac54-js":"swiper-bundle-ccdaac54-js","ios-transition-b4752795-js":"ios-transition-b4752795-js","md-transition-5ee3c425-js":"md-transition-5ee3c425-js","focus-visible-70713a0c-js":"focus-visible-70713a0c-js","input-shims-a4fc53ac-js":"input-shims-a4fc53ac-js","status-tap-2ec46489-js":"status-tap-2ec46489-js","swipe-back-d2cdbf9a-js":"swipe-back-d2cdbf9a-js","tap-click-606f325e-js":"tap-click-606f325e-js"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
